<script setup lang="ts">
/**
 * LoadingSkeleton — semantic alias for `Skeleton`.
 *
 * The existing `Skeleton` primitive supports `variant`,
 * `rows`, `cols`, `height`. This wrapper exists so reading the
 * template tells you "this is a loading placeholder" without
 * having to know that `Skeleton` means the same thing.
 *
 *   <LoadingSkeleton variant="row" :rows="5" :cols="7" />
 *
 * Otherwise identical to `Skeleton`. New code can use either.
 */
import Skeleton from './Skeleton.vue'

defineProps({
  variant: { type: String, default: 'line' },
  rows: { type: Number, default: 1 },
  cols: { type: Number, default: 4 },
  height: { type: String, default: '' },
})
</script>

<template>
  <Skeleton :variant="variant" :rows="rows" :cols="cols" :height="height" />
</template>
